import React from 'react';

function getSkillColorClass(skill: number) {
  if (!Number.isFinite(skill)) return 'bg-gray-100 text-gray-700';
  if (skill >= 0.5) return 'bg-green-100 text-green-800';
  if (skill >= 0) return 'bg-yellow-100 text-yellow-800';
  return 'bg-red-100 text-red-800';
}

export default function SkillBadge({skill}: {skill: number | null | undefined}) {
  if (skill === null || skill === undefined) return null;
  const className = getSkillColorClass(skill);

  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-1 text-xs ring-1 ring-inset ring-gray-500/10 ${className}`}
      title="CRPSS vs LTA"
    >
      CRPSS {skill.toFixed(2)}
    </span>
  );
}
